<template>
  <div class="w-[100%]">
    <div @click="() => (showDialog = true)">PICKLIST</div>
    <PrimeDialog
      v-model:visible="showDialog"
      :header="'Select ' + props.placeholder"
      class="min-w-[60%] min-h-[40%]"
    >
      <PrimePickList v-model="list">
        <template #sourceheader>
          <div>

          </div>
          <PrimeInputText
            :Placeholder="'Search ' + props.placeholder"
            class="w-full"
            v-model="searchText"
          />
        </template>
        <template #item="{ item }">
          <div>{{ item[props.displayKey ?? "Name"] }}</div>
        </template>
      </PrimePickList>
    </PrimeDialog>
  </div>
</template>

<script setup lang="ts">
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    options?: any[];
    fetchOptions?: boolean;
    editable?: boolean;
    endpoint?: string;
    displayKey?: string;
    valueKey?: string;
    responseKey?: string;
    limit?: number;
    filterEnabled?: boolean;
    filter?: { [key: string]: any };
    tokenData?: { [key: string]: any };
    placeholder?: string;
  }>(),
  {
    disabled: false,
    editable: false,
    loading: false,
    fetchOptions: false,
    responseKey: "Results",
    limit: 20, //no limit on multi-selects
    filterEnabled: false, //no filter on multi-selects
    filter: () => ({}),
  }
);

const value = defineModel<any>("value");
//const actualValue = defineModel<any>("actual");
const showDialog = ref<boolean>(false);
const currentPage = ref<number>(1);
const searchText = ref<string>("");

if (!props.endpoint) {
  console.error("Endpoint is required for picklist");
  throw new Error("Endpoint is required for picklist");
}

const list = ref<any[]>([[], []]);
const total = ref<number>(0);

const { data: options } = useFetch(props.endpoint, {
  method: "get",
  query: {
    take: props.limit,
    skip: (currentPage.value - 1) * props.limit,
  },
  watch: [currentPage, searchText],
  onRequest({ options }) {
    let additionalQuery: Indexable = {};
    if (searchText.value && searchText.value !== "") {
      additionalQuery[(props.displayKey ?? "Name") + "Contains"] =
        searchText.value;
    }
    if (props.filterEnabled) {
      additionalQuery = { ...additionalQuery, ...props.filter };
    }
    options.query = { ...options.query, ...additionalQuery };
  },
  transform(res: Indexable) {
    const values = res[props.responseKey ?? "Results"];
    list.value[0] = values.filter((v: any) => !list.value[1].find((l: any) => l[props.valueKey ?? "Id"] === v[props.valueKey ?? "Id"]));
    return values;
  },
});


const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== "") {
    return true;
  }
  return false;
});

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();

function changeEventHandler($event: any) {
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
